export enum EmailOptInSource {
  ACADEMY_IMPORT = 'academy-import',
  CONTACT_FORM = 'contact-form',
  UNKNOWN_MIGRATION = 'unknown-migration',
  WEBSITE_POPUP = 'website-popup',
  WEBSITE_SUBSCRIBE_BOX = 'website-subscribe-box',
}
